import {DEFAULT_FILTER_ID} from '../constants';
import {defaultFilterActionSet} from '../store/filterPanel/actions/defaultFilterActionSet';
import {editedFilterActionSet} from '../store/filterPanel/actions/editedFilterActionSet';

export const getDefaultOrEditedFilterAction = (
    filterId: number
) => {
    return filterId === DEFAULT_FILTER_ID ? defaultFilterActionSet : editedFilterActionSet
};
